import { createApi } from 'api/common/createApi'
import config, { API_TYPES } from 'constants/api-config'

export const awardsApi = createApi({
  baseURL: config[API_TYPES.AWARDS_API_URI],
})
